module.exports = __webpack_public_path__ + "static/Isabelle-664f3717af0567799f1335c6f8190359.png";